import script from "./notfound.vue?vue&type=script&setup=true&lang=js"
export * from "./notfound.vue?vue&type=script&setup=true&lang=js"

import "./notfound.vue?vue&type=style&index=0&id=5d14e263&lang=css"

const __exports__ = script;

export default __exports__